
















































































































































import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import { getModule } from 'vuex-module-decorators';
import Choices from '@/store/modules/Choices';
import Viewpoints from '@/store/modules/Viewpoints';
import Scoring from '@/store/modules/Scoring';
import WorkspaceOptions from '@/store/modules/WorkspaceOptions';
import Decisions from '@/store/modules/Decisions';
import ViewpointFactorScore from '@/components/scoring-input/ViewpointFactorScore.vue';
import FactorValueDisplay from '@/components/common/FactorValueDisplay.vue';
import { Factor, FactorGroup } from '@/api/model/FactorResource';
import Modelling from '@/store/modules/Modelling';
import { indexOf } from 'node_modules/@types/lodash';
import ViewpointFactorScoreGrowingTable from "@/components/scoring-input/ViewpointFactorScoreGrowingTable.vue";

const modellingModule = getModule(Modelling);
const decisionsModule = getModule(Decisions);
const choicesModule = getModule(Choices);
const viewpointModule = getModule(Viewpoints);
const scoringModule = getModule(Scoring);
const workspaceOptionsModule = getModule(WorkspaceOptions);

@Component({
    components: { FactorValueDisplay, ViewpointFactorScore,  TableRowViewpointFactorScore: ViewpointFactorScoreGrowingTable, },
})
export default class TableSingleChoiceScoringComparison extends Vue {
    @Prop({ default: 0, type: Number })
    factorLevel!: number;

    @Prop()
    tableFactorGroup: FactorGroup;

    @Prop()
    columnWidths!: any;

    @Prop()
    choiceIds!: string[];

    private selectedFactorId: null | string = null;

    private mounted() {
        if (this.tableFactorGroup.childrenIds.length > 0) {
            let visibleChildren = this.tableFactorGroup.childrenIds.filter((factor: any) =>
                this.isFactorVisible(factor)
            );
            this.selectedFactorId = visibleChildren[0];
        }
    }

    get selectedDecision() {
        return decisionsModule.selectedDecision;
    }

    get choices() {
        return choicesModule.choices;
    }

    get selectedChoice() {
        return choicesModule.selectedChoice
    }

    get choicesList() {
        return choicesModule.choicesList
    }

    get choiceFirstCol() {
        return workspaceOptionsModule.choiceFirstCol;
    }

    get activeChoice() {
        return choicesModule.selectedChoiceId
    }

    set activeChoice(choiceId: string) {
        choicesModule.selectChoice(choiceId)
    }

    get selectedViewpoint() {
        if (viewpointModule.selectedViewpoints && viewpointModule.activeViewpointId) {
            return viewpointModule.decisionViewpointsMap[viewpointModule.activeViewpointId];
        }
    }

    get tableChildren() {
        return this.tableFactorGroup.childrenIds.map(cId => this.factors[cId])
    }

    get tableGroupChildrenId() {
        let tableGroupChildrenId = [];
        for (let childrenId of this.tableFactorGroup.childrenIds) {
            if (this.isFactorVisible(childrenId))
                tableGroupChildrenId.push(this.factors[childrenId]);
        }
        if (tableGroupChildrenId.length > 0) {
            let visibleChildren = this.tableFactorGroup.childrenIds.filter((factor: any) =>
                this.isFactorVisible(factor)
            );

            this.selectedFactorId = visibleChildren[0];
        }
        return tableGroupChildrenId;
    }

    get viewpointFactorResources() {
        if (this.selectedViewpoint) {
            return (
                viewpointModule.viewpointFactorResources[this.selectedViewpoint.viewpointId] || {}
            );
        }
        return {};
    }

    get factors() {
        return modellingModule.publishedModelFactorResources;
    }

    get choiceVisibility() {
        return workspaceOptionsModule.choiceVisibility;
    }

    get choiceVisibilityCount() {
        return workspaceOptionsModule.choiceVisibilityCount;
    }

    get contributingVisibility() {
        return workspaceOptionsModule.contributingFactorVisibility;
    }

    get factorListTree() {
        return modellingModule.factorListTree;
    }

    get isFactorListActive() {
        return workspaceOptionsModule.activeFactorLists.length > 0;
    }

    get showNonListFactors() {
        return workspaceOptionsModule.showNonListFactors;
    }

    get leftCol() {
        let children = this.tableFactorGroup.childrenIds;
        let indexOfSelected = children.indexOf(this.selectedFactorId)
        if(indexOfSelected === 0) {
            return children[children.length - 1]
        }
        else {
            return children[indexOfSelected - 1]
        }
    }

    get rightCol() {
        let children = this.tableFactorGroup.childrenIds;
        let indexOfSelected = children.indexOf(this.selectedFactorId)
        if(indexOfSelected === children.length - 1) {
            return children[0]
        }
        else {
            return children[indexOfSelected + 1]
        }
    }

    get columnRuleExists() {
        const colsWithRule = this.tableChildren.filter((factor: Factor) => this.checkFactorForRules(factor.id));
        if (colsWithRule.length > 0) {
            return true;
        } else
            return false;
    }

    private checkFactorForRules(factorId: string) {
        if (this.viewpointFactorResources[factorId] && this.viewpointFactorResources[factorId].scoringDefinition) {
            if (this.viewpointFactorResources[factorId].scoringDefinition.type != "MANUAL") {
                return true;
            }
            else {
                return false;
            }
        } else {
            if ((this.factors[factorId] as Factor).scoringDefinition != null) {
                if ((this.factors[factorId] as Factor).scoringDefinition.type === "MANUAL" ) {
                    return false;
                }
                else {
                    return true;
                }
            }
        }
    }

    get leftChoice() {
        let indexOfSelected = this.choiceIds.indexOf(this.activeChoice)
        if(indexOfSelected === 0) {
            return this.choiceIds[this.choiceIds.length - 1]
        } else {
            return this.choiceIds[indexOfSelected - 1]
        }
    }

    get rightChoice() {
        let indexOfSelected = this.choiceIds.indexOf(this.activeChoice)
        if(indexOfSelected === this.choiceIds.length - 1) {
            return this.choiceIds[0]
        } else {
            return this.choiceIds[indexOfSelected + 1]
        }
    }

    get singularChoiceLabel() {
        return decisionsModule.singularChoiceLabel
    }

    get editComments() {
        return workspaceOptionsModule.editComments;
    }

    get showFactorData() {
        return workspaceOptionsModule.showFactorData;
    }

    private isFactorVisible(resourceId: string) {
        if (this.showNonListFactors || !this.isFactorListActive) {
            // return  this.contributingVisibility || (!this.contributingVisibility  && (!this.viewpointFactorResources[resourceId] || this.viewpointFactorResources[resourceId].numWeightingDots > 0))
            return true;
        } else {
            if (
                this.isFactorListActive &&
                this.factorListTree[resourceId] &&
                !this.showNonListFactors
            ) {
                return true;
            } else return false;
        }
    }

     get maxNumberRows() {
        let dataLengths = this.tableChildren
            .map((tc: any) => this.choices[this.activeChoice][tc.dataField])
            .filter((data: any) => data != null && Array.isArray(data))
            .map((data: any[]) => data.length)
        return Math.max(0, ...dataLengths)
    }

    private cycleLeft() {
        this.activeChoice = this.leftChoice

    }

    private cycleRight() {
        this.activeChoice = this.rightChoice
    }

    private getWidth(type: string) {
        switch (type) {
            case 'TEXT':
                return 160;
            case 'FILE':
            case 'CATEGORICAL':
                return 140;
        }
        return 120;
    }
}
